import { PlaceListDTO, PlacesReqParams } from '@/features/places/types/places.dto';
import { fetchEcommAPI } from '@/lib/http/clients/ecommApiClient';
import { buildQueryParams } from '@/lib/http/queryParamsBuilder';

export const fetchPlaces = async ({ opt, ...rest }: PlacesReqParams) =>
  fetchEcommAPI<PlaceListDTO>(`/shop/places${buildQueryParams(rest)}`, {
    ...(opt || {})
  });
